import { TaggedError } from "../tagged-error.js";
export class InvalidCredentialsError extends TaggedError {
    constructor() {
        super("InvalidCredentialsError");
    }
}
